/* eslint no-shadow: "off", no-param-reassign: ["error", { "props": false }], no-console: "off", quotes: "off" */
import axios from 'axios';
import auth from '../../../common/auth';
import common from '../common/index';
import i18n from '../i18n/index';

export default {
  /* eslint-disable */
  checkIfLinkIsValid({ commit }, data) {
    return axios({
      url: `api/checkIfLinkIsValid?code=${data.code}`,
      method: 'GET',
    }).then((response) => {
      const responseData = response.data;
      if (responseData.responseEnum === 'OPERATION_SUCCESS') {
        commit({ type: 'updateUnauthorizedMsisdn', unauthorizedMsisdn: responseData.data.msisdn });
        commit({ type: 'updateCode', code: responseData.data.code });
        commit('game/updateGameType', responseData.data.gameType, { root: true });
        commit('validTransitionForFreeGameMethod', true);
      }
      return response;
    }).catch((error) => {
      console.log(`Invoking api/checkIfLinkIsValid failed with the following error: ${error}`);
    });
  },
  saveCPC({ commit }, data) {
    return axios({
      url: `api/saveCPC?refUrl=${data.value.refUrl}&publisherId=${data.value.publisherId}&cpc=${data.value.cpc}&clickid=${data.value.clickid}`,
      method: 'GET',
    }).then(() => {
      commit({ type: 'updateCPC', cpc: null });
      commit({ type: 'updatePublisherId', publisherId: null });
      commit({ type: 'updateRefUrl', refUrl: null });
      commit({ type: 'storeClickid', clickid: null });
    }).catch((error) => {
      console.log(`Invoking api/saveCPC failed with the following error: ${error}`);
    });
  },
  updateIntegrationInfo({ commit }, data) {
    commit({ type: 'setIntegrationInfo', value: { name: data.name, data: data.value } });
  },
  checkIfURLisBlocked({ commit }, data) {
    return axios({
      url: `api/checkIfURLisBlocked?refUrl=${data.value.refUrl}&publisherId=${data.value.publisherId}`,
      method: 'GET',
    }).catch((error) => {
      console.log(`Invoking api/checkIfURLisBlocked failed with the following error: ${error}`);
    });
  },
  getReferralUrl() {
    return axios({
      url: 'api/getRegisterUrl',
      method: 'GET',
    });
  },
  getDecodedStatus({ commit }, encoded) {
    return axios({
      url: 'api/getStatus',
      method: 'GET',
      params: {
        status: encoded,
      },
    });
  },
  getUserExistsInCore({ commit }, data) {
    return axios({
      url: 'api/userExistsInCore',
      method: 'GET',
      params: {
        msisdn: data,
      },
    });
  },
  getUserIsRegistered({ commit }, data) {
    return axios({
      url: 'api/isUserRegistered',
      method: 'GET',
      params: {
        msisdn: data,
      },
    });
  },
  proceedWithSearchingOpponent({ dispatch, commit, rootState }) {
    // console.clear();
    console.log(`Invoking api/gameToResumeExists?msisdn=${rootState.common.userDetails.msisdn}`);
    return axios({
      method: 'get',
      url: 'api/gameToResumeExists',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      console.log('inside gameToResumeExists');
      const responseData = response.data;
      console.log('responseData:');
      console.log(responseData);
      if (responseData.responseEnum === 'NO_GAME_EXISTS') {
        console.log('NO_GAME_EXISTS');
        commit('game/setGameInProgress', false, { root: true });
      } else if (responseData.responseEnum === 'OPERATION_SUCCESS') {
        console.log('OPERATION_SUCCESS');
        commit('game/setGameInProgress', true, { root: true });
      }
    }).catch((error) => {
      dispatch('profile/logoutUserFromAuthorizedPages', null, { root: true });
      console.log(`Invoking api/proceedWithSearchingOpponent failed with the following error: ${error}`);
    });
  },
  storeVersionInfo({ commit }) {
    return axios({
      url: 'publicapi/getVersionInfo',
      method: 'GET',
    }).then((response) => {
      commit({ type: 'setVersionInfo', value: JSON.parse(response.data.data) });
    }).catch((error) => {
      console.log(`unable to get version info: ${error}`);
    });
  },
  // eslint-disable-next-line
  testControllerForGoogleAnalytics({ commit }, payload) {
    return axios({
      url: `publicapi/logAnalytics?state=${payload.userDataObject.state}&trackingId=${payload.userDataObject.trackingId}&path=${payload.userDataObject.path}`,
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).catch((error) => {
      console.log(`Invoking api/logAnalytics failed with the following error: ${error}`);
    });
  },
  getRequiredServerData({ dispatch }) {
    return dispatch('profile/getUserLoginDetails', null, { root: true })
      .then(() => dispatch('i18n/getLocaleAndTranslations', null, { root: true }))
      .then(() => dispatch('profile/storeAvailablePrizeTypes', localStorage.getItem('locale'), { root: true }))
      .then(() => dispatch('facebookSDKApi'))
      .then(() => dispatch('profile/storeVisitorWinners', localStorage.getItem('locale'), { root: true }))
      .then(() => dispatch('setSplashProperties'))
      .then(() => dispatch('setApplicationProperties'));
  },
  sendFacebookImage({ dispatch, commit }) {
    console.log('SendFacebookImage Process in Duel db');
    return axios({
      url: 'api/updateFacebookImage',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        facebookImage: localStorage.getItem('FacebookImage'),
      },
    }).then((response) => {
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        commit('deletePreviousFacebookImage');
        commit('storeFacebookImage', localStorage.getItem('FacebookImage'));
        // avatar Gender is missing
      }
      console.log(response);
    }).catch((error) => {
      dispatch('profile/logoutUserFromAuthorizedPages', null, { root: true });
      console.log(`Invoking api/sendFacebookImage failed with the following error: ${error}`);
    });
  },
  setSplashProperties({ commit }) {
    return axios({
      url: `publicapi/getSplashProperties`,
      method: 'GET',
    }).then((response) => {
      // success callback
      commit({ type: 'updateSplashUrl', value: response.data.data.splashUrl });
      commit({ type: 'updateSplashTimer', value: response.data.data.splashTimer });
    }).catch((error) => {
      console.log(`Invoking public/getSplashProperties failed with the following error: ${error}`);
    });
  },
  updateDisplayAvatar({ dispatch, commit }) {
    return axios({
      url: 'api/updateDisplayAvatar',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((responseDisplayAvatar) => {
      if (responseDisplayAvatar.data.responseEnum === 'OPERATION_SUCCESS') {
        console.log('------responseDisplayAvatar-------------', responseDisplayAvatar.data.data);
        commit({ type: 'setDisplayAvatar', item: responseDisplayAvatar.data.data });
      }
    }, (responseDisplayAvatar) => {
      // error callback
      // eslint-disable-next-line
      console.log(responseDisplayAvatar);
    }).catch((error) => {
      dispatch('profile/logoutUserFromAuthorizedPages', null, { root: true });
      console.log(`Invoking api/updateDisplayAvatar failed with the following error: ${error}`);
    });
  },
  sendAvatarCall({ dispatch, commit }, avatarGenderChoice) {
    console.log('SendAvatar Process in Duel db');
    return axios({
      url: 'api/updateAvatar',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        avatar: localStorage.getItem('Avatar'),
        avatarGender: avatarGenderChoice,
      },
    }).then((response) => {
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        commit('deletePreviousAvatar');
        commit('storeAvatar', localStorage.getItem('Avatar'));
        commit('setNewAvatarGender', avatarGenderChoice);
        commit('storeUserAvatar', localStorage.getItem('Avatar'));
        // avatar Gender is missing
      }
      console.log(response);
    }).catch((error) => {
      dispatch('profile/logoutUserFromAuthorizedPages', null, { root: true });
      console.log(`Invoking api/updateAvatar failed with the following error: ${error}`);
    });
  },
  reOptinProcess({ dispatch, commit }) {
    return axios({
      url: 'api/reoptin',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).catch((error) => {
      dispatch('profile/logoutUserFromAuthorizedPages', null, { root: true });
      console.log(`Invoking api/reOptinProcess failed with the following error: ${error}`);
    });
  },
  optoutCall({ dispatch, commit }) {
    return axios({
      url: 'api/optout',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).catch((error) => {
      dispatch('profile/logoutUserFromAuthorizedPages', null, { root: true });
      console.log(`Invoking api/optoutCall failed with the following error: ${error}`);
    });
  },
  storeOperator({ commit }, operator) {
    commit({ type: 'setOperator', value: operator });
  },
  setApplicationProperties({ commit, dispatch }) {
    return axios({
      url: 'publicapi/getApplicationProperties',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      commit({ type: 'setHideJackpot', value: response.data.data.hideJackpot });
      commit({ type: 'setJackpotCountdownDay', value: response.data.data.jackpotCountdownDay });
      commit({ type: 'setMinGamesToPlay', value: response.data.data.minGamesToPlay });
      commit({ type: 'setShowMsisdnInProfilePage', value: response.data.data.showMsisdnInProfilePage });
      commit({ type: 'setSingleOptinEnabled', value: response.data.data.isSingleOptinEnabled });
      commit({ type: 'setHideChangePassword', value: response.data.data.hideChangePassword });
      commit({ type: 'setHideLangSelection', value: response.data.data.hideLangSelection });
      commit({ type: 'setHideLeaderboard', value: response.data.data.hideLeaderboard });
      commit({ type: 'setShowLoginEmail', value: response.data.data.showLoginEmail });
      commit({ type: 'setMergedParam', value: response.data.data.mergedParam });
      commit({ type: 'setIntegrationHeader', value: response.data.data.integrationConfig });
      commit({ type: 'updateAvatarGrouping', value: response.data.data.avatarGrouping });
      commit({ type: 'updateFreeTrialStripe', value: response.data.data.freeTrialStripe });
      commit({ type: 'updateLogoOnFooter', value: response.data.data.logoOnFooter });
      commit({ type: 'updateCheckBox' , value: response.data.data.checkBoxEnabled });
      commit({ type: 'updateCookiesPopUp' , value: response.data.data.cookiesPopUpEnabled });
      commit({ type: 'updateTrackingId', value: response.data.data.trackingId });
      commit({ type: 'updateVatBanner', value: response.data.data.vatBanner });
      commit({ type: 'updateFacebookPixelId', value: response.data.data.facebookPixelId });
      commit({ type: 'updateReoptinOnestep', value: response.data.data.reoptinOnestep });
      commit({ type: 'storeConnectionPoints', value: response.data.data.connectionPoints });
      commit({ type: 'updateTwoStepRegistration', value: response.data.data.twoStepRegistration });
      commit({ type: 'updateSimpleRegistration', value: response.data.data.simpleRegistration });
      commit({ type: 'setLastRandomRound', value: response.data.data.finalRoundNumber });
      // WAG-519: FB is deprecated — hardcoded off, the backend facebookFunctionality property is ignored
      commit({ type: 'storeFacebookFunctionality', value: false });
      commit({ type: 'setHideWinners', value: response.data.data.hideWinners });
      commit({ type: 'storeTimeRounds', value: response.data.data.timeRoundList });
      commit({ type: 'storeWinnersShowMsisdn', value: response.data.data.winnersShowMsisdn });
      commit({ type: 'storeHidePrizePage', value: response.data.data.hidePrizePage });
      commit({ type: 'setPurchaseBundleFromUnsubUser', value: response.data.data.purchaseBundleFromUnsubUser });
      commit({ type: 'setTimeWinnerIndication', value: response.data.data.timeWinnerIndication });
      commit({ type: 'setTimeRoundIntro', value: response.data.data.timeRoundIntro });
      commit({ type: 'setSecForMatchedCards', value: response.data.data.secForMatchedCards });
      commit({ type: 'updateFreeTrialRedirectionUrl', value: response.data.data.freeTrialRedirectionUrl });
      commit({ type: 'updateFreeTrialPoints', value: response.data.data.freeTrialPoints });
      commit({ type: 'updateFreeTrialGuaranteedPrize', value: response.data.data.freeTrialGuaranteedPrize });
      commit({ type: 'setInviteConfig', value: JSON.parse(response.data.data.inviteConfig) });
      commit({ type: 'storePushNotificationsPublicKey', value: response.data.data.pushNotificationsInfo });
      commit({ type: 'storePrizeSectionEnabledAtLeaderBoard', value: response.data.data.hidePrizeSectionEnabledAtLeaderBoard });
      commit({ type: 'setMaximunmDigitsLenght', value: response.data.data.maxLengthPinDigits });
      commit({ type: 'setFallingItemsGameCss', value: response.data.data.fallingItemsGameCss });
      commit({ type: 'setTimerForLanternGame', value: response.data.data.timerForLanternGame });
      commit({ type: 'setPuzzleGameCss', value: response.data.data.puzzleGameCss });
      commit({ type: 'setTimerForPuzzleGame', value: response.data.data.timerForPuzzleGame });


      const isMultiOperatorEnabled = response.data.data.multiOperatorEnabled;
      commit({ type: 'setMultiOperator', value: isMultiOperatorEnabled });
      if (isMultiOperatorEnabled) {
        commit({ type: 'setMultiOperatorKeys', value: response.data.data.multiOperatorKeys });
        commit({ type: 'setMultiOperatorDisplayNames', value: response.data.data.multiOperatorDisplayNames });
        commit({ type: 'setMultiOperatorDisplayedNamesInRegisterPage', value: response.data.data.multiOperatorDisplayedNamesInRegisterPage });
      }
      localStorage.setItem('ga_tracking', response.data.data.trackingId);
      commit({ type: 'storeDuelSkin', value: response.data.data.duelSkin });
      dispatch('common/skinCss', null, { root: true });
    }).catch((error) => {
      console.log(`Invoking api/getApplicationProperties failed with the following error: ${error}`);
    });
  },
  skinCss() {
    if (i18n.state.currentLocale === 'AR' || i18n.state.currentLocale === 'FA' || i18n.state.currentLocale === 'PS') {
      document.getElementById('skinid').href = `/static/skins/skin_${common.state.duelSkin}/css/skin_AR.css`;
    } else {
      document.getElementById('skinid').href = `/static/skins/skin_${common.state.duelSkin}/css/skin.css`;
    }
  },
  // eslint-disable-next-line
  facebookSDKApi({commit, state}) {
    // WAG-519: FB is deprecated — skip the getFbInfo call and the SDK load unless facebookFunctionality is enabled (defaults to false)
    if (!state.facebookFunctionality) {
      return Promise.resolve();
    }
    return axios({
      url: 'publicapi/getFbInfo',
      method: 'GET',
    }).then((response) => {
      /* eslint-disable */
      commit({ type: 'setFbAppId', value: response.data.data });
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: response.data.data,
          autoLogAppEvents: true,
          xfbml: true,
          cookie: true,
          version: 'v6.0',
          status: true,
        });
      };
      (function (d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) window.FB = null;
        js = d.createElement(s);
        js.id = id;
        js.src = `//connect.facebook.net/${state.availableFBLanguagesForSDK[i18n.state.currentLocale]}/all.js#version=v6.0&appId=${response.data.data}&status=true&cookie=true&xfbml=true`;
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
      // according to facebookIntegration methods for Api calls
      window.connectTofb = null;
      window.loginTofb = null;
      /* eslint-enable */
    });
  },
  // eslint-disable-next-line
  sendPushSubscriptionInfoToServer({ commit, dispatch }, sub) {
    axios({
      url: 'api/sendPushSubscriptionInfo',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        pushSubInfo: JSON.stringify(sub),
      },
    }).then((response) => {
      console.log('send sub response: ', response);
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        dispatch('profile/broadcastLogin', '', { root: true });
      }
    });
  },

  callDVPassIdentification({ commit }, isDailySubscription) {
    return axios({
      url: 'api/requestDVPassIdentification',
      method: 'GET',
      params: {
        isDailySubscription,
      },
    }).then((response) => {
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        commit({ type: 'setDVPassIdentificationId', value: response.data.data.identificationId });
        commit({ type: 'setDVPassResponse', value: response.data.data });
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'DVPass API error');
      }
    }).catch((error) => {
      console.log(`Invoking api/requestDVPassIdentification failed with the following error: ${error}`);
      throw error;
    });
  },
  // Purpose: Calls backend API to generate secure JWT token instead of frontend generation
  // Security: JWT is generated on backend with proper HMAC SHA256 signing
  generateDVPassJWT(isDailySubscription) {
    return axios({
      url: 'api/generateDVPassJWT',
      method: 'GET',
      params: {
        isDailySubscription: isDailySubscription || false,
      },
    }).then((response) => {
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        const jwtData = response.data.data;
        console.log('DVPass JWT generated successfully:', jwtData);
        return jwtData.jwt;
      } else {
        throw new Error(response.data.message || 'JWT generation failed');
      }
    }).catch((error) => {
      console.log(`Invoking api/generateDVPassJWT failed with the following error: ${error}`);
      throw error;
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/common/actions.js